import $ from 'jquery';
import { debounce } from '../utils/debounce';

const headerHeight = () => {
	const el = {
		target: '.elementor-location-header',
	};

	const init = () => {
		$(function () {
			exec();

			$(window).on('resize', debounce(exec, 300));
		});
	};

	const exec = () => {
		const targetHeight = $(el.target).height();
		$(document.body).css('--header-height', `${targetHeight}px`);
		$(el.target)
			.find(`.e-con[data-settings]`)
			.each(function () {
				const $this = $(this);
				const elementorSetting = JSON.parse(
					$this.attr('data-settings'),
				);

				if (!elementorSetting['sticky_anchor_link_offset']) return;

				elementorSetting['sticky_anchor_link_offset'] = targetHeight;

				$this.attr('data-settings', JSON.stringify(elementorSetting));
			});
	};

	init();
};

try {
	headerHeight();
} catch (error) {
	console.error(error);
}
